export default function r(...o){o.forEach(e=>{Boolean(e)&&typeof e.remove=="function"&&e.remove()})}
